<template>
  <div class="callOrderManagement">
    <div class="callOrderManagement-m">
      <el-form
        :inline="true"
        :model="formsubmit"
        @keyup.enter.native.prevent="enterSearchMember(formsubmit)"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
      >
        <el-form-item label="搜索内容:">
          <el-input
            v-model.trim="formsubmit.content"
            clearable
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="处理状态">
          <el-select
            v-model="formsubmit.dealStatus"
            clearable
            placeholder="请选择处理状态"
            filterable
          >
            <el-option
              v-for="(item, index) in dealStatusList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="回访状态:">
          <el-select
            v-model="formsubmit.orderType"
            clearable
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="(item, index) in orderTypeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间查询:">
          <el-date-picker
            :editable="false"
            v-model="formsubmit.orderTime"
            unlink-panels
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="warning"
            icon="el-icon-plus"
            plain
            @click.native.prevent="handleAdd"
            >新增</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="info"
            icon="el-icon-search"
            plain
            @click.native.prevent="onSubmit"
            >导出</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            plain
            @click.native.prevent="onSubmit"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="danger" icon="el-icon-delete" plain @click="onClear"
            >清空查询选择</el-button
          >
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <el-table
          v-loading="loading"
          :data="orderList"
          style="width: 100%"
          :row-style="tableRowStyle"
          :header-cell-style="tableHeaderColor"
          @selection-change="selsChange"
          highlight-current-row
        >
          <el-table-column
            label="序号"
            min-width="50"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.sort }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="投诉单号"
            min-width="180"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.orderNo }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="投诉人"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="联系方式"
            min-width="150"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.tele }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="关联工单"
            min-width="180"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{
                scope.row.contantOrderNo
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="处理状态"
            min-width="100"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.dealStatus }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="处理人员"
            min-width="100"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.dealman }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="处理时间"
            min-width="180"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.dealTime }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="回访状态"
            min-width="100"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.backStatus }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="回访人员"
            min-width="100"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.backman }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="回访时间"
            min-width="180"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.backTime }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="投诉内容"
            min-width="150"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.toushu }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="录音"
            min-width="100"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span
                ><img
                  src="@/assets/callcenter/sounds.png"
                  alt=""
                  class="handedness"
                  style="
                    margin-right: 2px;
                    width: 12px;
                    height: 12px;
                    vertical-align: middle;
                  "
              /></span>
              <span>播放录音</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="100" align="center">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-circle-check-outline"
                @click="handleEdit(scope.$index, scope.row)"
                >修改状态</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye"
        ></el-pagination>
      </div>
    </div>
    <!-- 新增dialog -->
    <el-dialog
      :title="operation ? '新增投诉' : '修改工单'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="900px"
      @close="closeDialogFormVisible"
    >
      <el-form
        ref="dataForm"
        :model="dataForm"
        :rules="dataFormRules"
        label-width="160px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="投诉单号:" prop="orderNo">
              <p style="height: 40px; line-height: 40px">
                {{ dataForm.orderNo }}
              </p>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="关联工单:" prop="contantOrderNo">
              <el-popover placement="bottom-start" width="700" trigger="focus">
                <el-radio-group v-model="radio" @change="changeOrder">
                  <el-radio :label="1">呼叫工单</el-radio>
                  <el-radio :label="2">服务工单</el-radio>
                </el-radio-group>
                <el-form
                  ref="dataForm"
                  :model="dataForm"
                  :rules="dataFormRules"
                  label-width="160px"
                >
                  <el-row :gutter="20">
                    <el-col :span="9">
                      <el-form-item label="联系电话:" prop="orderNo">
                        <el-input v-model="phone"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="9">
                      <el-form-item label="客户姓名:" prop="orderNo">
                        <el-input v-model="name"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="3">
                      <el-button type="primary">查询</el-button>
                    </el-col>
                    <el-col :span="3">
                      <el-button type="primary" @click="clear">重置</el-button>
                    </el-col>
                  </el-row>
                </el-form>
                <el-table
                  :data="hujiaoOrder"
                  :row-style="tableRowStyle"
                  :header-cell-style="tableHeaderColor"
                  @row-click="clickRow"
                >
                  <el-table-column
                    property="sort"
                    align="center"
                    label="序号"
                  ></el-table-column>
                  <el-table-column
                    width="150"
                    align="center"
                    property="orderNo"
                    label="工单编号"
                  ></el-table-column>
                  <el-table-column
                    property="name"
                    align="center"
                    label="客户姓名"
                  ></el-table-column>
                  <el-table-column
                    property="phone"
                    align="center"
                    label="联系方式"
                  ></el-table-column>
                  <el-table-column
                    property="program"
                    align="center"
                    label="服务项目"
                  ></el-table-column>
                  <el-table-column
                    property="deal"
                    align="center"
                    label="处理结果"
                  ></el-table-column>
                </el-table>
                <el-pagination
                  background
                  layout="total,prev, pager, next"
                  :total="7"
                  align="center"
                >
                </el-pagination>
                <el-input
                  slot="reference"
                  v-model="dataForm.contantOrderNo"
                ></el-input>
              </el-popover>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="投诉人:" prop="name">
              <el-input
                v-model.trim="dataForm.name"
                placeholder="请输入投诉人"
                maxlength="14"
                style="width: 220px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="处理人员:" prop="dealman">
              <p style="height: 40px; line-height: 40px">
                {{ dataForm.dealman }}
              </p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="联系电话:"
              prop="tele"
              style="position: relative"
            >
              <el-input
                v-model.trim="dataForm.tele"
                placeholder="请输入联系电话"
                maxlength="14"
                style="width: 220px"
                :disabled="!operation"
              ></el-input>
              <img
                v-if="!operation"
                src="@/assets/callcenter/phone.png"
                style="height: 30px; position: absolute; top: 4px; left: 230px"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="处理时间:" prop="dealTime">
              <p style="height: 40px; line-height: 40px">
                {{ dataForm.dealTime }}
              </p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="处理状态:" prop="dealStatus">
              <el-select
                v-model="dataForm.dealStatus"
                clearable
                placeholder="请选择处理状态"
                filterable
              >
                <el-option
                  v-for="(item, index) in dealStatusList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="投诉内容:" prop="toushu">
            <el-input type="textarea" v-model="dataForm.toushu"></el-input>
          </el-form-item>
        </el-row>
        <h3 v-if="!operation" style="color: green">回访记录</h3>
        <el-row v-if="!operation">
          <el-col :span="12">
            <el-form-item label="回访人员:" prop="backman">
              <el-input
                v-model.trim="dataForm.backman"
                placeholder="请输客户姓名"
                maxlength="14"
                style="width: 220px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="回访时间:" prop="backTime">
              <el-date-picker
                v-model="dataForm.backTime"
                type="datetime"
                placeholder="选择日期时间"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!operation">
          <el-col :span="12">
            <el-form-item label="回访状态:" prop="backStatus">
              <el-select
                v-model="dataForm.backStatus"
                clearable
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="(item, index) in orderTypeList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="submit(dataForm)"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import util from "@/utils/util.js";
export default {
  data() {
    return {
      name: "",
      phone: "",
      visible: false,
      operation: true,
      submitLoading: false,
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      orderList: [],
      hujiaoOrder1: [
        {
          sort: 1,
          orderNo: "HJ201911241629",
          name: "云新建",
          phone: "17652142589",
          program: "上门送餐",
          deal: "服务完成",
        },
        {
          sort: 2,
          orderNo: "HJ201911241630",
          name: "章慧嘉",
          phone: "18652142589",
          program: "上门送餐",
          deal: "服务完成",
        },
        {
          sort: 3,
          orderNo: "HJ201911241631",
          name: "柏忠林",
          phone: "15652142589",
          program: "上门送餐",
          deal: "服务完成",
        },
        {
          sort: 4,
          orderNo: "HJ201911241632",
          name: "邹文杰",
          phone: "13652142589",
          program: "上门送餐",
          deal: "服务完成",
        },
        {
          sort: 5,
          orderNo: "HJ201911241633",
          name: "戚淑慧",
          phone: "17652142589",
          program: "上门送餐",
          deal: "服务完成",
        },
        {
          sort: 6,
          orderNo: "HJ201911241634",
          name: "李清权",
          phone: "19652142589",
          program: "上门送餐",
          deal: "服务完成",
        },
        {
          sort: 7,
          orderNo: "HJ201911241635",
          name: "孙白杨",
          phone: "13152142589",
          program: "上门送餐",
          deal: "服务完成",
        },
      ], //关联工单编号
      hujiaoOrder2: [
        {
          sort: 1,
          orderNo: "HJ201911241630",
          name: "李莫",
          phone: "17652142589",
          program: "上门送餐",
          deal: "服务完成",
        },
        {
          sort: 2,
          orderNo: "HJ201911241630",
          name: "李莫",
          phone: "17652142589",
          program: "上门送餐",
          deal: "服务完成",
        },
        {
          sort: 3,
          orderNo: "HJ201911241630",
          name: "李莫",
          phone: "17652142589",
          program: "上门送餐",
          deal: "服务完成",
        },
        {
          sort: 4,
          orderNo: "HJ201911241630",
          name: "李莫",
          phone: "17652142589",
          program: "上门送餐",
          deal: "服务完成",
        },
        {
          sort: 5,
          orderNo: "HJ201911241630",
          name: "李莫",
          phone: "17652142589",
          program: "上门送餐",
          deal: "服务完成",
        },
        {
          sort: 6,
          orderNo: "HJ201911241630",
          name: "李清",
          phone: "17652142589",
          program: "上门送餐",
          deal: "服务完成",
        },
        {
          sort: 7,
          orderNo: "HJ201911241630",
          name: "李清",
          phone: "17652142589",
          program: "上门送餐",
          deal: "服务完成",
        },
      ],
      radio: 1,
      orderList: [
        {
          sort: 1,
          orderNo: "HJ201911241628",
          name: "朱兆芳",
          tele: "15926105967",
          contantOrderNo: "HJ201911241633",
          dealStatus: "已处理",
          dealman: "云新建",
          dealTime: "2023/08/23 16:36:30",
          backStatus: "回访成功",
          backman: "云新建",
          backTime: "2023/08/22 15:00:25",
          toushu: "服务态度不好",
        },
        {
          sort: 2,
          orderNo: "HJ201911241627",
          name: "李建国",
          tele: "13972303561",
          contantOrderNo: "HJ201911241632",
          dealStatus: "已处理",
          dealman: "章慧嘉",
          dealTime: "2023/08/23 15:48:40",
          backStatus: "回访成功",
          backman: "章慧嘉",
          backTime: "2023/08/22 12:30:30",
          toushu: "服务态度不好",
        },
        {
          sort: 3,
          orderNo: "HJ201911241626",
          name: "邱秀珍",
          tele: "15971688892",
          contantOrderNo: "HJ201911241631",
          dealStatus: "已处理",
          dealman: "柏忠林",
          dealTime: "2023/08/23 11:20:10",
          backStatus: "回访成功",
          backman: "柏忠林",
          backTime: "2023/08/22 15:00:25",
          toushu: "服务态度不好",
        },
      ],
      orderListOne: [
        {
          sort: 1,
          orderNo: "HJ201911241630",
          name: "刘英子",
          tele: "17601253854",
          contantOrderNo: "HJ201911241630",
          dealStatus: "已处理",
          dealman: "航小波",
          dealTime: "2020-07-24 14:22:34",
          backStatus: "回访成功",
          backman: "航小波",
          backTime: "2020-07-24 14:22:34",
          toushu: "服务态度不好",
        },
        {
          sort: 2,
          orderNo: "HJ201911241630",
          name: "刘英子",
          tele: "17601253854",
          contantOrderNo: "HJ201911241630",
          dealStatus: "已处理",
          dealman: "航小波",
          dealTime: "2020-07-24 14:22:34",
          backStatus: "回访成功",
          backman: "航小波",
          backTime: "2020-07-24 14:22:34",
          toushu: "服务态度不好",
        },
        {
          sort: 3,
          orderNo: "HJ201911241630",
          name: "刘英子",
          tele: "17601253854",
          contantOrderNo: "HJ201911241630",
          dealStatus: "已处理",
          dealman: "航小波",
          dealTime: "2020-07-24 14:22:34",
          backStatus: "回访成功",
          backman: "航小波",
          backTime: "2020-07-24 14:22:34",
          toushu: "服务态度不好",
        },
        {
          sort: 4,
          orderNo: "HJ201911241630",
          name: "刘英子",
          tele: "17601253854",
          contantOrderNo: "HJ201911241630",
          dealStatus: "已处理",
          dealman: "航小波",
          dealTime: "2020-07-24 14:22:34",
          backStatus: "回访成功",
          backman: "航小波",
          backTime: "2020-07-24 14:22:34",
          toushu: "服务态度不好",
        },
        {
          sort: 5,
          orderNo: "HJ201911241630",
          name: "刘英子",
          tele: "17601253854",
          contantOrderNo: "HJ201911241630",
          dealStatus: "已处理",
          dealman: "航小波",
          dealTime: "2020-07-24 14:22:34",
          backStatus: "回访成功",
          backman: "航小波",
          backTime: "2020-07-24 14:22:34",
          toushu: "服务态度不好",
        },
        {
          sort: 6,
          orderNo: "HJ201911241630",
          name: "刘英子",
          tele: "17601253854",
          contantOrderNo: "HJ201911241630",
          dealStatus: "已处理",
          dealman: "航小波",
          dealTime: "2020-07-24 14:22:34",
          backStatus: "回访成功",
          backman: "航小波",
          backTime: "2020-07-24 14:22:34",
          toushu: "服务态度不好",
        },
        {
          sort: 7,
          orderNo: "HJ201911241630",
          name: "刘英子",
          tele: "17601253854",
          contantOrderNo: "HJ201911241630",
          dealStatus: "已处理",
          dealman: "航小波",
          dealTime: "2020-07-24 14:22:34",
          backStatus: "回访成功",
          backman: "航小波",
          backTime: "2020-07-24 14:22:34",
          toushu: "服务态度不好",
        },
        {
          sort: 8,
          orderNo: "HJ201911241630",
          name: "刘英子",
          tele: "17601253854",
          contantOrderNo: "HJ201911241630",
          dealStatus: "已处理",
          dealman: "航小波",
          dealTime: "2020-07-24 14:22:34",
          backStatus: "回访成功",
          backman: "航小波",
          backTime: "2020-07-24 14:22:34",
          toushu: "服务态度不好",
        },
        {
          sort: 9,
          orderNo: "HJ201911241630",
          name: "刘英子",
          tele: "17601253854",
          contantOrderNo: "HJ201911241630",
          dealStatus: "已处理",
          dealman: "航小波",
          dealTime: "2020-07-24 14:22:34",
          backStatus: "回访成功",
          backman: "航小波",
          backTime: "2020-07-24 14:22:34",
          toushu: "服务态度不好",
        },
        {
          sort: 10,
          orderNo: "HJ201911241630",
          name: "刘英子",
          tele: "17601253854",
          contantOrderNo: "HJ201911241630",
          dealStatus: "已处理",
          dealman: "航小波",
          dealTime: "2020-07-24 14:22:34",
          backStatus: "回访成功",
          backman: "航小波",
          backTime: "2020-07-24 14:22:34",
          toushu: "服务态度不好",
        },
      ],
      orderListTwo: [
        {
          sort: 1,
          orderNo: "HJ201911241630",
          name: "刘英子",
          tele: "17601253854",
          contantOrderNo: "HJ201911241630",
          dealStatus: "已处理",
          dealman: "航小波",
          dealTime: "2020-07-24 14:22:34",
          backStatus: "回访成功",
          backman: "航小波",
          backTime: "2020-07-24 14:22:34",
          toushu: "服务态度不好",
        },
        {
          sort: 2,
          orderNo: "HJ201911241630",
          name: "刘英子",
          tele: "17601253854",
          contantOrderNo: "HJ201911241630",
          dealStatus: "已处理",
          dealman: "航小波",
          dealTime: "2020-07-24 14:22:34",
          backStatus: "回访成功",
          backman: "航小波",
          backTime: "2020-07-24 14:22:34",
          toushu: "服务态度不好",
        },
        {
          sort: 3,
          orderNo: "HJ201911241630",
          name: "刘英子",
          tele: "17601253854",
          contantOrderNo: "HJ201911241630",
          dealStatus: "已处理",
          dealman: "航小波",
          dealTime: "2020-07-24 14:22:34",
          backStatus: "回访成功",
          backman: "航小波",
          backTime: "2020-07-24 14:22:34",
          toushu: "服务态度不好",
        },
        {
          sort: 4,
          orderNo: "HJ201911241630",
          name: "刘英子",
          tele: "17601253854",
          contantOrderNo: "HJ201911241630",
          dealStatus: "已处理",
          dealman: "航小波",
          dealTime: "2020-07-24 14:22:34",
          backStatus: "回访成功",
          backman: "航小波",
          backTime: "2020-07-24 14:22:34",
          toushu: "服务态度不好",
        },
        {
          sort: 5,
          orderNo: "HJ201911241630",
          name: "刘英子",
          tele: "17601253854",
          contantOrderNo: "HJ201911241630",
          dealStatus: "已处理",
          dealman: "航小波",
          dealTime: "2020-07-24 14:22:34",
          backStatus: "回访成功",
          backman: "航小波",
          backTime: "2020-07-24 14:22:34",
          toushu: "服务态度不好",
        },
        {
          sort: 6,
          orderNo: "HJ201911241630",
          name: "刘英子",
          tele: "17601253854",
          contantOrderNo: "HJ201911241630",
          dealStatus: "已处理",
          dealman: "航小波",
          dealTime: "2020-07-24 14:22:34",
          backStatus: "回访成功",
          backman: "航小波",
          backTime: "2020-07-24 14:22:34",
          toushu: "服务态度不好",
        },
        {
          sort: 7,
          orderNo: "HJ201911241630",
          name: "刘英子",
          tele: "17601253854",
          contantOrderNo: "HJ201911241630",
          dealStatus: "已处理",
          dealman: "航小波",
          dealTime: "2020-07-24 14:22:34",
          backStatus: "回访成功",
          backman: "航小波",
          backTime: "2020-07-24 14:22:34",
          toushu: "服务态度不好",
        },
      ],
      sels: [], //列表选中列的checkbox集合
      totalDataNumber: 3, //数据的总数,
      loading: "", //加载数据中
      //查询传入的参数
      formsubmit: {
        content: "",
        dealStatus: "",
        orderType: "",
        orderTime: "",
      },
      dealStatusList: [
        {
          value: "0",
          label: "未处理",
        },
        {
          value: "1",
          label: "处理中",
        },
        {
          value: "2",
          label: "已处理",
        },
        {
          value: "3",
          label: "已回访",
        },
      ],
      orderTypeList: [
        {
          value: "0",
          label: "未成功",
        },
        {
          value: "1",
          label: "回访未成功",
        },
        {
          value: "2",
          label: "回访成功",
        },
      ],
      orderPeopleList: [
        {
          value: "0",
          label: "张三",
        },
        {
          value: "1",
          label: "李四",
        },
        {
          value: "2",
          label: "王五",
        },
        {
          value: "3",
          label: "赵六",
        },
      ],

      // 处理报警记录dialog
      dialogFormVisible: false,
      dataForm: {
        orderTime: "",
        orderNo: "orderNo",
        customerName: "",
        phone: "",
        orderType: "",
        dealStatus: "",
        name: "航小波",
        dealman: "航小波",
        dealTime: "2019-11-25 11:30",
        contantOrderNo: "",
      },
      formLabelWidth: "120px",
      dataFormRules: {},
      //element-ui 日期选择器如何限制只能选择一个月，超过一个月不能选择，也就是在选定起始日期时，只能向后面选择30天，同时不能选择超过今天的日期
      pickerMinDate: "",
      dateRange: [],
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
      pickerServiceTime: {
        disabledDate(time) {
          let nowData = new Date();
          nowData = new Date(nowData.setDate(nowData.getDate() - 1));
          return time < nowData;
        },
      },
    };
  },
  methods: {
    //选中行
    handleSelectionChange(val) {
      console.log("val:", val);
    },
    clear() {
      (this.name = ""), (this.phone = "");
    },
    //清空 重置选取的值
    onClear() {
      this.formsubmit = {
        content: "",
        dealStatus: "",
        orderType: "",
        orderTime: "",
      };
    },

    //点击查询
    onSubmit() {},

    //键盘事件 按下键盘回车 查询
    enterSearchMember(formsubmit) {},

    /* 
      接单时间的change
    */

    changeServiceTime(val) {
      console.log(val);
      this.dataForm.orderTime = util.formatDate.format(
        new Date(val),
        "yyyy-MM-dd hh:mm:ss"
      );
      console.log(this.dataForm.orderTime);
    },

    /* 
      新增
    */
    handleAdd() {
      this.dialogFormVisible = true;
      this.operation = true;

      this.dataForm = {
        orderTime: "",
        orderNo: "HJ201911241629",
        customerName: "",
        phone: "",
        orderType: "",
        dealStatus: "",
        name: "航小波",
        dealman: "航小波",
        dealTime: "2019-11-25 11:30",
        contantOrderNo: "",
      };
    },

    /* 
      新增提交数据
    */
    submit(dataForm) {
      this.dialogFormVisible = false;
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
        }
      });
    },

    /* 
      修改
    */
    handleEdit(index, row) {
      console.log(index, row);
      this.dialogFormVisible = true;
      this.operation = false;
      //数据回显
      this.dataForm = row;
    },

    //关闭弹窗
    closeDialogFormVisible() {
      console.log(this.$refs.dataForm, "啥奥斯卡");
      this.$refs.dataForm.resetFields();
      this.dataForm = {
        orderTime: "",
        orderNo: "",
        customerName: "",
        phone: "",
        orderType: "",
        dealStatus: "",
      };
    },

    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      // return this.rowStyle;
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },

    //关闭处理报警dialog的回调
    closeDealAlarm() {
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    //处理报警取消按钮
    cancelDealAlarm() {
      this.dialogFormVisible = false;
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    //处理报警记录 弹出dialog框
    handleDeal(index, row) {
      console.log(index, row);
      this.form = Object.assign({}, row);
      console.log(this.form);
      this.dialogFormVisible = true;
    },

    //选择的勾选的列
    selsChange: function (sels) {
      this.sels = sels;
      console.log(sels);
    },

    //点击新增里的表格
    clickRow(row, column, event) {
      this.dataForm.contantOrderNo = row.orderNo;
      this.visible = false;
    },

    //点击新增表格里的单选框
    changeOrder(val) {
      if (val == 1) {
        this.hujiaoOrder = this.hujiaoOrder1;
      } else {
        this.hujiaoOrder = this.hujiaoOrder2;
      }
    },

    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      if (this.pageNum == 1) {
        this.orderList = this.orderListOne;
      } else if (this.pageNum == 2) {
        this.orderList = this.orderListTwo;
      } else if (this.pageNum == 3) {
        this.orderList = this.orderListThree;
      }
    },
  },
  watch: {
    currentPage(oldV, newV) {
      console.log(oldV, newV);
    },
  },

  created() {},

  mounted() {
    //this.orderList = this.orderListOne;
    this.hujiaoOrder = this.hujiaoOrder1;
  },
  destroyed() {},
};
</script>
<style lang="scss" scoped>
// .callOrderManagement {
//   .callOrderManagement-m {
//     // padding: 0px 0 0 5px;
//   }
// }
.fenye {
  padding: 30px 0;
  background: #fff;
}

// ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
//处理报警记录的dialog
@media screen and (min-width: 1200px) {
  ::v-deep .dealalarm .el-dialog {
    width: 30% !important;
  }
}
</style>


